(function () {
  if (window.__ptBands) return; window.__ptBands = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ptb a[data-pt]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(sms|tel):/.test(href) || /direct\.lc\.chat/.test(href)) return;
    var b = a.closest('[data-ph]'), ph = b ? b.getAttribute('data-ph') : '';
    emit('select_promotion', { promotion_id: 'bands-' + a.getAttribute('data-pt'), promotion_name: ph + '|' + (a.getAttribute('data-pn') || ''),
      creative_slot: ph, link_url: href });
  }, true);
  var bs = document.querySelectorAll('.ptb[data-ph]'), io2 = 'IntersectionObserver' in window;
  function show(b) {
    var im = b.querySelectorAll('img[data-src]');
    for (var i = 0; i < im.length; i++) {
      var x = im[i], ss = x.getAttribute('data-srcset');
      if (ss) x.setAttribute('srcset', ss);
      x.setAttribute('src', x.getAttribute('data-src'));
      x.removeAttribute('data-srcset'); x.removeAttribute('data-src');
    }
  }
  if (io2) {
    var lo = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { show(es[i].target); lo.unobserve(es[i].target); }
    }, { rootMargin: '300px 0px' });
    for (var j = 0; j < bs.length; j++) lo.observe(bs[j]);
  } else { for (var k = 0; k < bs.length; k++) show(bs[k]); }
  var s = bs[0];
  if (s && io2) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        var ph = s.getAttribute('data-ph') || '';
        emit('view_promotion', { promotion_id: 'bands-shelf', promotion_name: ph + '|shelf', creative_slot: ph, link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(s);
  }
})();
